export const colors = [
  '#001622',
  '#FB393E',
  '#F5672F',
  '#FA8C2C',
  '#FAC151',
  '#83B667',
  '#339F80',
  '#B27DF2',
  '#6D4031',
  '#FFFFFF'
];

export const penSize = [5, 15, 30];
